// extracted by mini-css-extract-plugin
export default {"buyButton":"Pg_1_12_buyButton__l5Emr","right":"Pg_1_12_right__SJ+5E"};